import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "44",
  height: "44",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22S0 34.15 0 22"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#0B1228",
      "stroke-opacity": ".14",
      "stroke-width": ".5",
      d: "M22 .25C34.012.25 43.75 9.988 43.75 22S34.012 43.75 22 43.75.25 34.012.25 22 9.988.25 22 .25Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#22A06B",
      d: "M25.71 18.339q.174 0 .344.008c-.794-2.446-3.445-4.243-6.593-4.243-3.775 0-6.836 2.585-6.836 5.773 0 1.736.908 3.294 2.345 4.352l-.275 2.118 2.217-1.113a7.9 7.9 0 0 0 2.124.404 5.4 5.4 0 0 1-.161-1.314c0-3.477 3.247-5.985 6.836-5.985m-8.397.258a.781.781 0 1 1 0-1.563.781.781 0 0 1 0 1.563m4.296.005a.781.781 0 1 1 0-1.562.781.781 0 0 1 0 1.562"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#22A06B",
      d: "M31.375 24.324c0 1.33-.635 2.534-1.661 3.405v2.166l-1.904-1.099c-.65.22-1.358.341-2.1.341-3.127 0-5.663-2.155-5.663-4.813s2.536-4.813 5.664-4.813 5.664 2.155 5.664 4.813m-8.352-1.565a.781.781 0 1 0 1.563 0 .781.781 0 0 0-1.563 0m3.813 0a.781.781 0 1 0 1.563 0 .781.781 0 0 0-1.563 0"
    }, null, -1)
  ]))]))
}
export default { render: render }